import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from "@curves/ui-base";
import clsx from 'clsx';

function OverviewListToolbar({ className, alignItems = 'center', justifyContent, children, ...rest }) {
    return (
        <Stack className={clsx('overview-list__toolbar', className)} alignItems={alignItems} justifyContent={justifyContent} {...rest}>
            {children}
        </Stack>
    );
}

OverviewListToolbar.propTypes = {
    className: PropTypes.string,
    alignItems: PropTypes.string,
    justifyContent: PropTypes.string,
    children: PropTypes.node,
};

export default OverviewListToolbar;
